// ChoiceNode.jsx - Simplified choice node
import React from 'react';
import { Handle, Position } from 'reactflow';

export default function ChoiceNode({ data, selected }) {
  const { block, activeBlockId } = data;
  const isActive = block.id === activeBlockId;
  
  return (
    <div 
      className={`
        w-[260px] rounded-lg bg-white border-2 shadow-md transition-all
        ${isActive ? 'border-green-600 shadow-lg' : 'border-gray-300'}
        ${selected ? 'ring-2 ring-green-500' : ''}
      `}
    >
      {/* Node header */}
      <div className="bg-green-50 border-b border-green-100 p-3 rounded-t-lg">
        <div className="flex justify-between items-center">
          <h3 className="font-semibold text-gray-800 text-sm">
            {block.title || 'Decision'}
          </h3>
          <span className="text-xs text-green-600">
            {block.choices?.length || 0} options
          </span>
        </div>
      </div>
      
      {/* Node content */}
      <div className="p-3">
        {block.description && (
          <p className="text-xs text-gray-600 mb-3">
            {block.description}
          </p>
        )}

        {/* Choices list */}
        <div className="space-y-1">
          {block.choices?.map((choice, idx) => (
            <div 
              key={idx} 
              className="text-xs py-1 px-2 bg-green-50 rounded truncate"
            >
              {choice.label || `Option ${idx + 1}`}
            </div>
          ))}
        </div>
      </div>

      {/* Decision icon */}
      <div className="absolute top-2 right-2 w-4 h-4 bg-green-600 rounded-full flex items-center justify-center">
        <span className="text-white text-xs">?</span>
      </div>

      {/* Connection handles */}
      <Handle 
        type="target" 
        position={Position.Left} 
        className="w-3 h-3 !bg-green-600"
      />
      {/* Source handles for each choice */}
      {block.choices?.map((choice, idx) => (
        <Handle 
          key={idx}
          type="source" 
          position={Position.Right} 
          className="w-3 h-3 !bg-green-600"
          id={`choice-${idx}`}
          style={{ 
            top: `${40 + idx * 20}px`,
          }}
        />
      ))}
    </div>
  );
}